import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import { classes } from "../utils/classes";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { sxClassName, sxProps, sxPropTypes, textAlignPropTypes } from "../props/sx";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { utilityClassName, utilityProps, utilityPropTypes } from "../props/utility";

const Td = ({
	className = "",
	align,
	isBorderNone = false,
	isActive = false,
	utility = { ...utilityProps },
	sx = { ...sxProps },
	spacing = { ...spacingProps },
	verticalAlign,
	children,
	...props
}) => {
	const borderProp = isBorderNone ? { border: { width: 0 } } : {};
	return (
		<td
			className={classes(
				"table__td",
				isActive && "table-active",
				align && `table__td--${align}`,
				verticalAlign && `table__td-vertical-align--${verticalAlign}`,
				...utilityClassName(deepMergeProps({ ...borderProp }, pureProps(utility))),
				...sxClassName(sx),
				...spacingClassName(spacing),
				className,
			)}
			{...props}
		>
			{children}
		</td>
	);
};

Td.propTypes = {
	isActive: bool,
	isBorderNone: bool,
	align: textAlignPropTypes,
	className: string,
	utility: utilityPropTypes,
	sx: sxPropTypes,
	spacing: spacingPropTypes,
	children: node,
	verticalAlign: oneOf(["baseline", "top", "middle", "sub", "bottom", "text-top"]),
};

export default Td;
